@if (service.available) {
  <button
    type="button"
    class="dev-function-codes"
    [class.dev-function-codes--on]="service.enabled()"
    nz-popover
    nzPopoverTrigger="click"
    nzPopoverPlacement="bottomRight"
    nzPopoverOverlayClassName="dev-function-codes-popover"
    [nzPopoverContent]="panel"
    [(nzPopoverVisible)]="open"
    (nzPopoverVisibleChange)="onOpenChange($event)"
  >
    <span class="dev-function-codes__dot"></span>
    {{ label() }}
  </button>

  <ng-template #panel>
    <div class="dfc-panel">
      <div class="dfc-header">
        <div>
          <div class="dfc-header__title">
            Function codes
            <span class="dfc-header__badge">Dev only</span>
          </div>
          <div class="dfc-header__hint">
            @if (draftEnabled()) {
              Permissions are checked against the codes ticked below.
            } @else {
              Off — every feature is allowed, as dev normally behaves.
            }
          </div>
        </div>
        <nz-switch
          [ngModel]="draftEnabled()"
          (ngModelChange)="draftEnabled.set($event)"
        ></nz-switch>
      </div>

      <div class="dfc-body" [class.dfc-body--off]="!draftEnabled()">
        <input
          nz-input
          class="dfc-search"
          placeholder="Search code or name"
          [disabled]="!draftEnabled()"
          [ngModel]="search()"
          (ngModelChange)="search.set($event)"
        />

        <div class="dfc-list">
          @for (menu of visibleMenus(); track menu.code) {
            <div class="dfc-group">
              <div class="dfc-group__head">
                <label class="dfc-option dfc-option--menu">
                  <input
                    type="checkbox"
                    [disabled]="!draftEnabled()"
                    [checked]="draftCodes().has(menu.code)"
                    (change)="toggle(menu.code, $any($event.target).checked)"
                  />
                  <span class="dfc-option__name">{{ menu.name }}</span>
                  <span class="dfc-option__code">{{ menu.code }}</span>
                </label>
                @if (menu.items.length) {
                  <button
                    type="button"
                    class="dfc-group__all"
                    [disabled]="!draftEnabled()"
                    (click)="toggleGroup(menu)"
                  >
                    {{ isGroupSelected(menu) ? 'None' : 'All' }}
                  </button>
                }
              </div>
              @for (item of menu.items; track item.code) {
                <label class="dfc-option dfc-option--item">
                  <input
                    type="checkbox"
                    [disabled]="!draftEnabled()"
                    [checked]="draftCodes().has(item.code)"
                    (change)="toggle(item.code, $any($event.target).checked)"
                  />
                  <span class="dfc-option__name">{{ item.name }}</span>
                  <span class="dfc-option__code">{{ item.code }}</span>
                </label>
              }
            </div>
          } @empty {
            <div class="dfc-empty">No function code matches.</div>
          }
        </div>
      </div>

      <div class="dfc-footer">
        <span class="dfc-footer__count">
          {{ draftCodes().size }} of {{ totalCount }} selected
        </span>
        <button
          type="button"
          class="dfc-link"
          [disabled]="!draftEnabled()"
          (click)="selectAll()"
        >
          Select all
        </button>
        <button
          type="button"
          class="dfc-link"
          [disabled]="!draftEnabled()"
          (click)="clear()"
        >
          Clear
        </button>
        <button type="button" class="dfc-apply" (click)="apply()">Apply</button>
      </div>
    </div>
  </ng-template>
}
